/**
 * The corner badge on a reviewer's avatar in a reviewer stack, shared by the
 * human reviewers and cubic's logo so both carry their state the same way.
 */
// z-10 keeps the badge above the next avatar in the -space-x-1 stack, which
// would otherwise paint over the badge's right edge.
export const REVIEWER_BADGE_CLASS =
  'absolute -bottom-1 -right-1 z-10 flex h-3 min-w-3 items-center justify-center rounded-full bg-zinc-950 px-0.5 ring-1 ring-zinc-700';
